import { render } from "./VerificationPracticeSuccessScreen.vue?vue&type=template&id=b519a9ba"
import script from "./VerificationPracticeSuccessScreen.vue?vue&type=script&lang=js"
export * from "./VerificationPracticeSuccessScreen.vue?vue&type=script&lang=js"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__